export function getUniqueArrayElements<T = number | string | boolean | null | undefined>(array1: T[], array2: T[]): T[] {
  const combinedArray = (array1 || []).concat(array2 || []);

  return combinedArray.filter((id: T) => combinedArray.indexOf(id) === combinedArray.lastIndexOf(id));
}
